import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import "antd/lib/config-provider/style";
import _ConfigProvider from "antd/lib/config-provider";
import _isEqual from "lodash/isEqual";
var __jsx = React.createElement;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import '../../assets/nprogress.css';
import '../index.css';
import Amplify from '@aws-amplify/core';
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import Router, { useRouter } from 'next/router';
import NProgress from 'nprogress';
import { DefaultSeo } from 'next-seo';
import { wrapper } from 'redux/store';
import { useDispatch, useSelector } from 'react-redux';
import AppRouteProvider from 'utils/AppRouteProvider';
import ContentWrapper from 'components/ContentWrapper';
import TagManager from 'components/TagManager';
import { initTracking } from 'utils/tracking';
import UnauthorizedPage from 'pages/401';
import NotFoundPage from 'pages/404';
import Error from 'pages/_error';
import APIError from 'utils/errors/http/APIError';
import { brandColors, notAgreedToTermsStatus, cookiesAgreedCognitoKey } from 'const';
import 'antd/dist/antd.variable.min.css';
import { loadUser } from 'redux/actions/user';
import { setUpDispatch } from 'utils/http/fetchAPI';
_ConfigProvider.config({
  theme: {
    primaryColor: brandColors.DARK_LILAC,
    infoColor: brandColors.STEEL_PINK,
    warningColor: brandColors.STEEL_PINK
  }
});
NProgress.configure({
  showSpinner: false
});
Router.events.on('routeChangeStart', function () {
  return NProgress.start();
});
Router.events.on('routeChangeComplete', function () {
  return NProgress.done();
});
Router.events.on('routeChangeError', function () {
  return NProgress.done();
});
Amplify.configure({
  ssr: true
});
var addDashesToExperimentId = function addDashesToExperimentId(experimentId) {
  return experimentId.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
};
var WrappedApp = function WrappedApp(_ref) {
  var Component = _ref.Component,
    pageProps = _ref.pageProps;
  var httpError = pageProps.httpError,
    amplifyConfig = pageProps.amplifyConfig,
    errorOrigin = pageProps.errorOrigin;
  var dispatch = useDispatch();
  setUpDispatch(dispatch);
  var router = useRouter();
  var _router$query = router.query,
    urlExperimentId = _router$query.experimentId,
    secondaryAnalysisId = _router$query.secondaryAnalysisId;

  // If the experimentId exists (we are not is data management) and
  // is the old version (without dashes), then add them
  var experimentId = !urlExperimentId || urlExperimentId.includes('-') ? urlExperimentId : addDashesToExperimentId(urlExperimentId);
  var experimentData = useSelector(function (state) {
    return experimentId ? state.experimentSettings.info : {};
  }, _isEqual);
  var _useState = useState(!amplifyConfig),
    amplifyConfigured = _useState[0],
    setAmplifyConfigured = _useState[1];
  var environment = useSelector(function (state) {
    return state.networkResources.environment;
  });
  var cookiesAgreed = useSelector(function (state) {
    var _state$user;
    return (state === null || state === void 0 || (_state$user = state.user) === null || _state$user === void 0 || (_state$user = _state$user.current) === null || _state$user === void 0 ? void 0 : _state$user.attributes[cookiesAgreedCognitoKey]) || false;
  }) === 'true';
  useEffect(function () {
    initTracking(environment, cookiesAgreed);
  }, [cookiesAgreed, environment]);
  useEffect(function () {
    if (amplifyConfig && typeof window !== 'undefined') {
      var _amplifyConfig$Auth;
      if (amplifyConfig !== null && amplifyConfig !== void 0 && (_amplifyConfig$Auth = amplifyConfig.Auth) !== null && _amplifyConfig$Auth !== void 0 && _amplifyConfig$Auth.cookieStorage) {
        delete amplifyConfig.Auth.cookieStorage;
      }
      Amplify.configure(amplifyConfig);
      setAmplifyConfigured(true);
    }
  }, [amplifyConfig]);
  if (!amplifyConfigured) {
    return null;
  }
  var mainContent = function mainContent() {
    // If this is a not found error, show it without the navigation bar.
    if (Component === NotFoundPage) {
      return __jsx(Component, pageProps);
    }

    // If there was an error querying the API, display an error state.
    if (httpError) {
      if (httpError === 404) {
        var _projectType = errorOrigin === 'experiment' ? 'analysis' : 'pipeline run';
        return __jsx(NotFoundPage, {
          title: "".concat(_projectType, " doesn't exist"),
          subTitle: "We searched, but we couldn't find the ".concat(_projectType, " you're looking for."),
          hint: "It may have been deleted by the project owner."
        });
      }
      if (httpError === 403) {
        if (errorOrigin === 'experiment') {
          return __jsx(NotFoundPage, {
            title: "Analysis not found",
            subTitle: 'You don\'t have access to this analysis. The owner may have made it private.',
            hint: "If somebody gave you this link, they may need to invite you to their project."
          });
        }
        if (errorOrigin === 'secondaryAnalysis') {
          return __jsx(NotFoundPage, {
            title: "Pipeline run not found",
            subTitle: 'Or you don\'t have access to it.'
          });
        }
      }
      if (httpError === notAgreedToTermsStatus) {
        dispatch(loadUser());
        return __jsx(NotFoundPage, {
          title: "Terms agreement required",
          subTitle: "You cannot access your analysis in Trailmaker until you have agreed to our updated privacy policy.",
          hint: "Go to Insights or Pipeline to accept the terms.",
          primaryActionText: "Go to Insights or Pipeline"
        });
      }
      if (httpError === 401) {
        return __jsx(UnauthorizedPage, {
          title: "Log in to continue",
          subTitle: "We can't show you this page.",
          hint: "You may be able to view it by logging in."
        });
      }
      return __jsx(Error, {
        statusCode: httpError
      });
    }

    // Otherwise, load the page inside the content wrapper.
    return __jsx(AppRouteProvider, null, __jsx(ContentWrapper, {
      routeExperimentId: experimentId,
      routeAnalysisId: secondaryAnalysisId,
      experimentData: experimentData
    }, __jsx(Component, _extends({
      experimentId: experimentId,
      secondaryAnalysisId: secondaryAnalysisId,
      experimentData: experimentData
    }, pageProps))));
  };
  return __jsx(React.Fragment, null, __jsx(DefaultSeo, {
    titleTemplate: "%s \xB7 Trailmaker",
    defaultTitle: "Trailmaker",
    description: "Trailmaker turns your single cell datasets into meaningful biology. It\u2019s free for academic researchers, and you get world-class quality analytical insight: simple data upload, data integration for batch effect correction, beautiful publication-quality figures, and much more.",
    openGraph: {
      type: 'website',
      locale: 'en_US',
      site_name: 'Trailmaker'
    }
  }), __jsx(TagManager, {
    cookiesAgreed: cookiesAgreed,
    environment: environment
  }), __jsx(_ConfigProvider, null, mainContent(Component, pageProps)));
};

/* eslint-disable global-require */
WrappedApp.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var Component, ctx, store, req, query, res, err, pageProps, promises, _yield$import, getEnvironmentInfo, _yield$import2, getAuthenticationInfo, results, amplifyConfig, _yield$import3, withSSRContext, _withSSRContext, Auth, _yield$import4, getExperimentInfo, _yield$import5, getAnalysisInfo, _errorOrigin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = _ref2.Component, ctx = _ref2.ctx;
            store = ctx.store, req = ctx.req, query = ctx.query, res = ctx.res, err = ctx.err; // If a render error occurs, NextJS bypasses the normal page rendering
            // and returns `_error.jsx` instead, returning these parameters
            if (!err) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", {
              pageProps: {
                errorObject: err
              }
            });
          case 4:
            if (req) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", {
              pageProps: {}
            });
          case 6:
            if (!Component.getInitialProps) {
              _context.next = 12;
              break;
            }
            _context.next = 9;
            return Component.getInitialProps(ctx);
          case 9:
            _context.t0 = _context.sent;
            _context.next = 13;
            break;
          case 12:
            _context.t0 = {};
          case 13:
            pageProps = _context.t0;
            promises = [];
            _context.next = 17;
            return import('utils/ssr/getEnvironmentInfo');
          case 17:
            _yield$import = _context.sent;
            getEnvironmentInfo = _yield$import.default;
            promises.push(getEnvironmentInfo);
            _context.next = 22;
            return import('utils/ssr/getAuthenticationInfo');
          case 22:
            _yield$import2 = _context.sent;
            getAuthenticationInfo = _yield$import2.default;
            promises.push(getAuthenticationInfo);
            _context.next = 27;
            return Promise.all(promises.map(function (f) {
              return f(ctx, store);
            }));
          case 27:
            results = _context.sent;
            amplifyConfig = results[1].amplifyConfig;
            _context.prev = 29;
            _context.next = 32;
            return import('aws-amplify');
          case 32:
            _yield$import3 = _context.sent;
            withSSRContext = _yield$import3.withSSRContext;
            _withSSRContext = withSSRContext(ctx), Auth = _withSSRContext.Auth;
            Auth.configure(amplifyConfig.Auth);
            if (!(query !== null && query !== void 0 && query.experimentId)) {
              _context.next = 43;
              break;
            }
            _context.next = 39;
            return import('utils/ssr/getExperimentInfo');
          case 39:
            _yield$import4 = _context.sent;
            getExperimentInfo = _yield$import4.default;
            _context.next = 43;
            return getExperimentInfo(ctx, store, Auth);
          case 43:
            if (!(query !== null && query !== void 0 && query.secondaryAnalysisId)) {
              _context.next = 50;
              break;
            }
            _context.next = 46;
            return import('utils/ssr/getAnalysisInfo');
          case 46:
            _yield$import5 = _context.sent;
            getAnalysisInfo = _yield$import5.default;
            _context.next = 50;
            return getAnalysisInfo(ctx, store, Auth);
          case 50:
            return _context.abrupt("return", {
              pageProps: _objectSpread(_objectSpread({}, pageProps), {}, {
                amplifyConfig: amplifyConfig
              })
            });
          case 53:
            _context.prev = 53;
            _context.t1 = _context["catch"](29);
            console.error(_context.t1);
            if (!(_context.t1 instanceof APIError)) {
              // eslint-disable-next-line no-ex-assign
              _context.t1 = new APIError(500);
            }
            res.statusCode = _context.t1.statusCode;
            _errorOrigin = query !== null && query !== void 0 && query.experimentId ? 'experiment' : query !== null && query !== void 0 && query.secondaryAnalysisId ? 'secondaryAnalysis' : '';
            return _context.abrupt("return", {
              pageProps: _objectSpread(_objectSpread({}, pageProps), {}, {
                amplifyConfig: amplifyConfig,
                httpError: _context.t1.statusCode || true,
                errorOrigin: _errorOrigin
              })
            });
          case 60:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[29, 53]]);
  }));
  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();
/* eslint-enable global-require */

export default wrapper.withRedux(WrappedApp);